import {
  useListPayors,
  useListProvidersBySite,
  useListRolesByOrganization,
} from 'api/resource';
import { useEffect, useState } from 'react';
import { useCurrentSiteStore } from 'store/SiteStore';

export const useUserProviderManagementData = () => {
  const currentSite = useCurrentSiteStore();
  const providersResult = useListProvidersBySite({ siteID: currentSite?.id });
  const payorsResult = useListPayors();
  const rolesResult = useListRolesByOrganization({
    organizationID: currentSite?.organizationID,
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (
      providersResult.isLoading ||
      payorsResult.isLoading ||
      rolesResult.isLoading
    ) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [
    providersResult.isLoading,
    payorsResult.isLoading,
    rolesResult.isLoading,
  ]);

  const isError =
    providersResult.isError || payorsResult.isError || rolesResult.isError;
  const isFetching =
    providersResult.isFetching ||
    payorsResult.isFetching ||
    rolesResult.isFetching;
  const errorMessage =
    providersResult.error?.message ||
    payorsResult.error?.message ||
    rolesResult.error?.message;

  return {
    providers: providersResult.data || [],
    payors: payorsResult.data || [],
    roles: rolesResult.data || [],
    currentSite,
    isLoading,
    isError,
    isFetching,
    errorMessage,
    setIsLoading,
    refetchProviders: providersResult.refetch,
  };
};
